'use client';

import { useEffect, useRef } from 'react';
import { io, type Socket } from 'socket.io-client';

const WS_URL =
    (typeof window !== 'undefined' && (process.env.NEXT_PUBLIC_WS_URL || 'http://localhost:3000')) ||
    'http://localhost:3000';

let sharedSocket: Socket | null = null;

function getSocket(): Socket {
    if (!sharedSocket || !sharedSocket.connected) {
        sharedSocket = io(WS_URL, {
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionDelay: 2000,
        });
    }
    return sharedSocket;
}

export function useSocketEvent<T = unknown>(
    event: string,
    handler: (data: T) => void,
): void {
    const handlerRef = useRef(handler);
    handlerRef.current = handler;

    useEffect(() => {
        const socket = getSocket();
        const listener = (data: T) => handlerRef.current(data);
        socket.on(event, listener);
        return () => { socket.off(event, listener); };
    }, [event]);
}
